import React from 'react';
import { css } from '@emotion/react';

import { VolumeMuteIcon } from '$/images/FontAwesomeIcons';

import { withWebinarPlayerContext } from '../context';
import { PlayButtonSizePx } from './PlayButtonSizePx';
import { logger } from '$/utils/logger';

export const UnmuteButton = withWebinarPlayerContext(
  ['setMuted'],
  'UnmuteButton'
)<{
  className?: string;
}>(({ context: { setMuted }, className }) => {
  const onUnmute = React.useCallback<React.MouseEventHandler<HTMLElement>>(
    (e) => {
      e.preventDefault();
      e.stopPropagation();

      logger.debug('PLAY', '2082-3 clicked on unmute button');
      setMuted(false);
    },
    [setMuted]
  );

  return (
    <div
      className={`
      absolute z-player-control
      cursor-pointer
      w-full h-full flex flex-col items-center justify-center
      ${className}
    `}
      css={css`
        button > div {
          transition: transform 0.5s;
        }
        &:hover {
          button > div {
            transform: scale(1.1);
          }
        }
      `}
      onClick={onUnmute}
    >
      <button className='scale-control cursor-pointer pointer-events-none'>
        <div
          className='flex items-center justify-center'
          css={css`
            width: ${PlayButtonSizePx}px;
            height: ${PlayButtonSizePx}px;
            border: 5px solid #fff;
            border-radius: 50%;
            backdrop-filter: blur(10px);
            &:hover {
              backdrop-filter: blur(15px);
            }

            color: #fff !important;
            background: rgba(0, 0, 0, 0.5);
          `}
        >
          <VolumeMuteIcon
            css={css`
              -webkit-tap-highlight-color: transparent;
              width: ${Math.floor(PlayButtonSizePx * 0.5)}px;
              height: ${Math.floor(PlayButtonSizePx * 0.5)}px;
            `}
          />
        </div>
      </button>
    </div>
  );
});
